// extracted by mini-css-extract-plugin
export var aboveInput = "_hg-0";
export var actionButton = "_hg-5";
export var actionButtonContainer = "_hg-1";
export var actionIcon = "_hg-6";
export var aiInfoContainer = "_hg-2";
export var attachmentWrapper = "_hg-7";
export var bold = "_hg-3";
export var checkIcon = "_hg-8";
export var clickingRecipientBar = "_hg-11";
export var commentThreadSwitch = "_hg-a";
export var draftImage = "_hg-b";
export var draftImageContainer = "_hg-c";
export var draftImages = "_hg-e";
export var editButton = "_hg-g";
export var editor = "_hg-f";
export var editorContainer = "_hg-y";
export var editorErrorTooltipWrapper = "_hg-9";
export var headerDivider = "_hg-h";
export var icon = "_hg-i";
export var info = "_hg-j";
export var internal = "_hg-n";
export var internalDivider = "_hg-k";
export var internalMessage = "_hg-l";
export var messageInputCard = "_hg-m";
export var messageInputForm = "_hg-o";
export var messageInputFormInternal = "_hg-p";
export var options = "_hg-q";
export var publicMessageCustomer = "_hg-s";
export var publicMessageMerchant = "_hg-r";
export var removeImageButton = "_hg-d";
export var replyButtons = "_hg-t";
export var showSignatureButton = "_hg-u";
export var spinner = "_hg-v";
export var verticalButtonDivider = "_hg-4";
export var visibilitySelector = "_hg-w";
export var warning = "_hg-x";
export var wrappingText = "_hg-z";
export var writingInternalNoteTopBorder = "_hg-10";